import { Link } from '@tanstack/react-router'
import type { ComponentType, ReactNode } from 'react'

/**
 * A link to a loan screen.
 *
 * `Link` types its destination against the registered route tree, and the loan routes are
 * registered by the integrator after this area is built. The assertion is confined to this file —
 * see `loan-paths.ts` — and the runtime behaviour is unchanged: `Link` resolves the string it is
 * given exactly as it resolves a typed one.
 */
export interface LoanLinkProps {
  to: string
  replace?: boolean
  className?: string
  'aria-label'?: string
  'aria-current'?: 'page' | undefined
  children: ReactNode
}

const UntypedLink = Link as unknown as ComponentType<LoanLinkProps>

export function LoanLink(props: LoanLinkProps) {
  return <UntypedLink {...props} />
}
